const soundsData = {
	ding: require('../assets/audio/ding.mp3'),
	game1Music: require('../assets/audio/htx-music.mp3'),
	game2Music: require('../assets/audio/hhx-music.mp3'),
	game3Music: require('../assets/audio/stx-music.mp3'),
	game4Music: require('../assets/audio/hf-music.mp3'),
	game5Music: require('../assets/audio/hhx-music.mp3'),
}

module.exports = {soundsData};